import { ReactNode } from 'react';
import { LogInIcon } from 'lucide-react';

import MicrosoftIcon from '@/assets/ico/vendor/microsoft.svg?c';
import GoogleIcon from '@/assets/ico/vendor/google.svg?c';
import GithubIcon from '@/assets/ico/vendor/github.svg?c';

import { Button } from '@@/buttons';
import { Icon } from '@@/Icon';

const providers = {
  Microsoft: {
    icon: MicrosoftIcon,
    label: 'Login with Microsoft',
  },
  Google: {
    icon: GoogleIcon,
    label: 'Login with Google',
  },
  Github: {
    icon: GithubIcon,
    label: 'Login with GitHub',
  },
  OAuth: {
    icon: LogInIcon,
    label: 'Login with OAuth',
  },
};

export function OAuthLoginButton({
  provider,
  onClickShowInternalAuth,
  isInternalAuthVisible,
  loginUrl,
}: {
  provider: keyof typeof providers;
  onClickShowInternalAuth(): void;
  isInternalAuthVisible: boolean;
  loginUrl: string;
}) {
  const providerConfig = providers[provider];

  return (
    <div className="flex flex-col items-center gap-5">
      <OAuthButton
        icon={providerConfig.icon}
        label={providerConfig.label}
        href={loginUrl}
      />
      <Divider />
      {!isInternalAuthVisible && (
        <UseInternalAuthButton onClick={onClickShowInternalAuth} />
      )}
    </div>
  );
}

export function Divider() {
  return (
    <div className="striketext small text-muted flex w-11/12 items-center justify-center">
      or
    </div>
  );
}

export function UseInternalAuthButton({ onClick }: { onClick(): void }) {
  return (
    <Button
      color="primary"
      data-cy="use-internal-auth-btn"
      onClick={onClick}
      size="medium"
      className="w-full"
    >
      Use internal authentication
    </Button>
  );
}

function OAuthButton({
  icon,
  label,
  href,
}: {
  icon: ReactNode;
  label: ReactNode;
  href: string;
}) {
  return (
    <Button as="a" data-cy="oauth-btn" size="large" props={{ href }}>
      <Icon icon={icon} /> {label}
    </Button>
  );
}
